// extracted by mini-css-extract-plugin
export default {"divider":"DomainItemDivider_divider__EGKSv"};